<template>
    <div>
        <p class="server-issue">
            На сайте ведутся технические работы. Для записи на прием просим обращаться по телефонам:
            Регистратура ОМС: 8 ( 495 ) 620-81-06, Регистратура ДМС: 8 ( 495 ) 620-81-05, Платные мед. услуги: 8 ( 495 )
            620-81-07, Стоматология: 8 ( 499 ) 248-31-06
        </p>
        <div class="contact container">
            <content-header title="Контакты" style="padding-top: 10px" />

            <div class="contact__content">
                <div class="contact__first-row">

                    <div class="content-title">
                        Интерактивная карта
                    </div>

                    <h3 class="sentence">Подберите наиболее удобный маршрут вашего визита</h3>

                    <div class="contact__map">
                    </div>

                </div>
                <div class="contact__second-row">
                    <div class="content-title">
                        ФГБУ «Поликлиника №5»
                    </div>

                    <h3 class="sentence">Многопрофильная клиника с широким спектром специалистов.</h3>
                    <div class="column-left">
                        Россия, 119121<br>
                        г. Москва<br>
                        ул. Плющиха 14<br>
                        Метро Смоленская
                    </div>
                    <div class="contact__list">
                        <div class="list-item">
                            <span class="list-icon"></span>
                            <div class="list-value">
                                <div style="margin: 5px 0 0">
                                    <a href="tel:+74992482720"><strong>+7 (499) 248-27-20</strong></a>
                                </div>
                                <p style="margin: 16px 0 -12px;">Контактный центр:</p>
                                <div style="margin: 5px 0 0">
                                    <a href="tel:+74992485768"><strong>+7 (499) 248-57-68</strong></a>
                                </div>
                            </div>
                        </div>
                        <div class="list-item">
                            <span class="list-icon"></span>
                            <p class="list-value">
                                Регистратура ОМС:
                                <a href="tel:+74956208106"><strong>+7 (495) 620-81-06</strong></a>
                            </p>
                        </div>
                        <div class="list-item">
                            <span class="list-icon"></span>
                            <p class="list-value">
                                Регистратура ДМС:
                                <a href="tel:+74956208105"><strong>+7 ( 495 ) 620-81-05</strong></a>
                            </p>
                        </div>
                        <div class="list-item">
                            <span class="list-icon"></span>
                            <p class="list-value">
                                Платные мед. услуги:
                                <a href="tel:+74996208107"><strong>+7 ( 495 ) 620-81-07</strong></a>
                            </p>
                        </div>
                        <div class="list-item">
                            <span class="list-icon"></span>
                            <p class="list-value">
                                Стоматология:
                                <a href="tel:+74992483106"><strong>+7 ( 499 ) 248-31-06</strong></a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="contact__form">
                <div class="content-title">
                    Записаться на прием
                </div>

                <h3 class="sentence">Просим заполнить форму для записи</h3>

                <div class="form-container">
                    <div class="contact-cell-2x">
                        <div class="input-item">
                            <p> ФИО (обязательно) </p>
                            <input v-model="formData.full_name" type="text" placeholder="">
                            <span class="error-text" v-if="errorDisplay.full_name"
                                v-for="err in errorDisplay.full_name">{{
                                        err
                                }}</span>
                        </div>
                        <div class="input-item">
                            <p> Номер Телефона (обязательно) </p>
                            <div class="inner-input-wrapper phone-number">
                                <img alt="" src="../assets/images/Icon-awesome-phone-alt.svg" />
                                <span>+7</span>
                                <img class="flag" alt="" src="../assets/images/flag.png" />
                                <input-mask v-model="formData.phone" mask="999 99999999" placeholder="000-00000000"
                                    maskChar="_"></input-mask>
                            </div>
                            <span class="error-text" v-if="errorDisplay.phone" v-for="err in errorDisplay.phone">{{
                                    err
                            }}</span>
                        </div>
                    </div>
                    <div class="contact-cell">
                        <div class="input-item__right">
                            <font-awesome-icon class="select-arrow" icon="chevron-up" />
                            <select name="service_type" v-model="formData.service_type">
                                <option v-for="opt in serviceTypeOptions" :key="opt.name" :value="opt.value">{{ opt.name
                                }}
                                </option>
                            </select>
                            <span class="error-text" v-if="errorDisplay.service_type"
                                v-for="err in errorDisplay.service_type">{{
                                        err
                                }}</span>
                        </div>
                    </div>
                    <div class="contact-cell">
                        <div class="input-item">
                            <p> Причина обращения </p>
                            <textarea v-model="formData.details" rows="10"></textarea>
                            <span class="error-text" v-if="errorDisplay.details" v-for="err in errorDisplay.details">{{
                                    err
                            }}</span>
                        </div>
                    </div>
                    <div class="contact-cell">
                        <div class="check-box-wrapper">
                            <div class="check-box-inner-wrapper">
                                <label class="check-box-inner-wrapper">
                                    <span>Нажимая на кнопку, вы даете
                                        <a target="_blank" href="/static/files/Согласие.pdf">СОГЛАСИЕ</a>
                                        на обработку своих персональных данных в соответствии с
                                        <a target="_blank"
                                            href="/static/files/Положение-об-организации-работы-с-персональными-данными-и-Правила-работы-с-обезличенными-персональными-данными-1.pdf">ПОЛОЖЕНИЕМ</a>.
                                    </span>
                                    <input type="checkbox" v-model="formData.consent" checked="checked">
                                    <span class="checkmark"></span>
                                </label>
                                <span class="error-text" v-if="errorDisplay.consent"
                                    v-for="err in errorDisplay.consent">{{
                                            err
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="contact-cell">
                        <div class="input-item__right">
                            <button class="form-submit" :disabled="!formData.consent" @click="submitForm">Отправить
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="all-contact">
                <div class="all-contact__title">
                    <div class="row"></div>
                    <p>Все контакты</p>
                    <div class="row"></div>
                </div>
                <div class="all-contact__content">
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Администрация:</strong>
                        </p>

                        <div class="contact-content">
                            <p>тел. <a href="tel:+74956208132">+7 (495) 620-81-32</a><br>
                                тел. <a href="tel:+74992481020">+7 (499) 248-10-20</a><br>
                                факс: (499) 248-25-03<br>
                                почта: udz39@5-clinic.ru</p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Регистратура ОМС:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74956208106">+7 (495) 620-81-06</a><br>
                                тел. <a href="tel:+74992482720">+7 (499) 248-27-20</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Регистратура ДМС:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74956208105">+7 (495) 620-81-05</a><br>
                                тел. <a href="tel:+74992485768">+7 (499) 248-57-68</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Единый</strong><br>
                            <strong>диспетчерский пункт </strong><br>
                            <strong>скорой и неотложной </strong><br>
                            <strong>медицинской помощи </strong><br>
                            <strong>ФГБУ "Клиническая больница №1"</strong>
                        </p>
                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74956208105">+7 (495) 620-84-04</a><br>
                                тел. <a href="tel:+74992485768">+7 (499) 390-80-84</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Платные мед.услуги:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74956208107">+7 (495) 620-81-07</a><br>
                                тел. <a href="tel:+74992484938">+7 (499) 248-49-38</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Стоматология:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74992483106">+7 (499) 248-31-06</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Отдел прикрепления:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74992485769">+7 (499) 248-57-69</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Помощь на дому:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74992480760">+7 (499) 248-07-60</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Помощь на дому:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74992480760">+7 (499) 248-07-60</a></p>
                        </div>
                    </div>
                    <div class="contact-item">
                        <p class="contact-title">
                            <strong>Госпитализация:</strong>
                        </p>

                        <div class="contact-content">
                            <p style="text-align: left;">тел. <a href="tel:+74992483146">+7 (499) 248-31-46</a></p>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ContentHeader from "../components/layout/ContentHeader";
import InputMask from 'vue-input-mask';
import { ajax, apiUrls } from "@/store/urls";

export default {
    name: "contact",
    data() {
        return {
            formData: {
                full_name: '',
                service_type: null,
                phone: '',
                details: '',
                consent: false
            },
            serviceTypeOptions: [
                {
                    name: 'Выберите Вид Услуг',
                    value: null
                },
                {
                    name: 'Услуги ДМС',
                    value: 'Услуги ДМС'
                },
                {
                    name: 'Платные услуги',
                    value: 'Платные услуги'
                },
                {
                    name: 'Услуги ОМС',
                    value: 'Услуги ОМС'
                },
            ],
            errorDisplay: {},
        }
    },
    components: {
        ContentHeader,
        InputMask,
        FontAwesomeIcon,
    },
    methods: {
        formatData(inputData) {
            let data = {};

            data.full_name = inputData.full_name;
            data.service_type = inputData.service_type;
            data.phone = inputData.phone;
            data.details = inputData.details;
            data.consent = inputData.consent;

            for (const prop in data) {

                if ((!data[prop] || data[prop] === '') && !(data[prop] === false) && !(data[prop] === 0 || data[prop] === '0')) {
                    data[prop] = ''
                }
            }
            data.phone = data.phone !== '' ? `+7${data.phone}` : '';

            return data;
        },
        submitForm() {
            const emptyData = {
                full_name: '',
                service_type: null,
                phone: '',
                details: '',
                consent: false
            }
            ajax
                .post(apiUrls.makeAppointment, this.formatData(this.formData))
                .then(() => {
                    this.formData = { ...emptyData };
                    this.errorDisplay = {};
                }).catch(err => {
                    this.errorDisplay = err.response.data;
                })
        }
    },
    mounted() {
        let yandexMap = document.createElement('script');
        yandexMap.setAttribute('type', 'text/javascript');
        yandexMap.setAttribute('charset', 'utf-8');
        yandexMap.setAttribute('async', '');
        yandexMap.setAttribute('src', 'https://api-maps.yandex.ru/services/constructor/1.0/js/?sid=iipyg5K9GK-EK4oscYcu1h9LBnI_ioon&amp;width=100%&amp;height=380&amp;lang=ru_RU&amp;sourceType=constructor&amp;scroll=true');
        document.querySelector('.contact__map').appendChild(yandexMap)
    }
}
</script>

<style lang="scss" scoped>
.server-issue {
    margin: 10px 0 0;
    color: #ffffff;
    background: #ff0000;
    font-size: 14px;
    line-height: 18px;
    padding: 4px;
    width: 100%;
}

.contact {
    .sentence {
        color: #006688;
        font-size: 15px;
        padding: 20px 0;
        text-align: left;
    }

    .column-left {
        color: #666;
        text-align: left;
        font-size: 14px;
    }

    &__first-row {
        width: 69%;
    }

    &__second-row {
        width: 31%;
    }

    &__list {

        margin: 10px 0;

        .list-item {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px solid #E0E0E0;

            .list-icon {
                background-repeat: no-repeat;
                background-size: contain;
                width: 35px;
                height: 16px;
                margin: 7px 0;
                background-image: url("../assets/images/Icon metro-phone@2x.png");
            }

            .list-value {
                font-size: 13px;
                width: 100%;
                text-align: left;

                a {
                    float: right;
                    color: unset;
                    border-bottom: 1px dotted #3156A3;
                }
            }
        }

    }

    &__map {
        width: 550px;
        height: 380px;
        background-color: #707070;
    }

    &__form {

        .form-container {
            padding: 30px 0;
        }

        .contact-cell {
            margin-bottom: 17px;
            min-height: 30px;
        }

        .contact-cell-2x {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 13px;
            margin-bottom: 17px;
            min-height: 30px;
        }

        .input-item {

            &__right {
                float: right;
                width: fit-content;
                height: 30px;
                position: relative;
            }

            input {
                background: #FFFFFF 0 0 no-repeat padding-box;
                border: 1px solid #006687;
                border-radius: 4px;
                height: 30px;
                width: 100%;
                padding: 5px;
            }

            textarea {
                background: #FFFFFF 0 0 no-repeat padding-box;
                border: 1px solid #006687;
                border-radius: 4px;
                height: 137px;
                width: 100%;
                padding: 5px;
                resize: none;
            }

            p {
                text-align: left;
                font: normal normal bold 14px/16px Source Sans Pro;
                letter-spacing: 0;
                color: #006585;
                margin: 0 0 12px 0;
            }


        }

        .form-submit {
            text-align: center;
            width: 150px;
            height: 30px;
            background: #006687 0 0 no-repeat padding-box;
            border-radius: 4px;
            font: normal normal bold 14px/16px Source Sans Pro;
            letter-spacing: 0;
            color: #FFFFFF;

            &:disabled {
                cursor: not-allowed;
                opacity: 0.7;
            }
        }

        .select-arrow {
            top: 8px;
            position: absolute;
            right: 6px;
            width: 15px;
            height: 15px;
            color: white;
            transform: rotateX(180deg);
            pointer-events: none;
        }

        select {
            width: 191px;
            height: 30px;
            background: #006687 0 0 no-repeat padding-box;
            border-radius: 8px;
            text-align: left;
            font: normal normal normal 12px/15px Source Sans Pro;
            letter-spacing: 0;
            color: #FFFFFF;
            padding: 7px 15px;
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;

            option {
                color: #333333;
                background-color: #FFFFFF;

                &:checked {
                    color: #FFFFFF;
                    background-color: #006687;
                }
            }

            option:hover {
                color: #FFFFFF !important;
                background-color: #006687 !important;
            }
        }
    }

    .all-contact {
        display: flex;
        flex-direction: column;
        padding: 20px 0;

        &__title {
            display: flex;
            align-items: center;
            margin-bottom: 50px;

            .row {
                width: 40%;
                height: 1px;
                display: block;
                background-color: #707070;
                opacity: .2;
            }

            p {
                padding: 0 20px;
                font-size: 13px;
                color: black;
            }
        }

        &__content {
            display: flex;
            flex-wrap: wrap;

            .contact-item {
                width: 240px;
                text-align: left;
                margin-bottom: 20px;
                font-size: 12px;
                color: #666;


                strong {
                    font-weight: bold;
                    color: black;
                    font-family: sans-serif;
                }

                .contact-title {
                    font-size: 13px;
                    margin-bottom: 20px;
                }

                a {
                    color: #006688;
                    border-bottom: 1px dotted #006688;
                    margin-left: 4px;
                }
            }
        }

    }


    &__content {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;
    }
}

.inner-input-wrapper {
    border: none !important;
}

.inner-input-wrapper.phone-number {
    position: relative;
    height: 30px;
}

.inner-input-wrapper.phone-number>input {
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 75px;
}


.inner-input-wrapper.phone-number>img {
    position: absolute;
    width: 12px;
    height: 12px;
    top: 9px;
    left: 10px;
    z-index: 1;
}

.inner-input-wrapper.phone-number>span {
    position: absolute;
    width: 16px;
    height: 17px;
    top: 6px;
    left: 27px;
    font: normal normal normal 13px/17px Source Sans Pro;
    letter-spacing: 0;
    color: #707070;
    z-index: 1;
}

.inner-input-wrapper.phone-number>img.flag {
    position: absolute;
    width: 18px;
    height: 12px;
    top: 9px;
    left: 50px;
    z-index: 1;
}

.check-box-wrapper {
    text-align: left;
}

.check-box-wrapper span {
    text-align: left;
    font: normal normal normal 9px/11px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #707070;
    padding-left: 20px;
}

.check-box-wrapper a {
    font: normal normal normal 9px/11px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #006687
}

.check-box-inner-wrapper {
    display: block;
    position: relative;
}

.check-box-inner-wrapper input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 6px;
    left: 0;
    height: 14px;
    width: 14px;
    background-color: #FFFFFF;
    border: 1px solid #006A81;
    border-radius: 2px;
    padding: 0 !important;
}

.check-box-inner-wrapper:hover input~.checkmark {
    background-color: #ccc;
}

.check-box-inner-wrapper input:checked~.checkmark {
    background-color: #006A81;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.check-box-inner-wrapper input:checked~.checkmark:after {
    display: block;
}

.check-box-inner-wrapper .checkmark:after {
    left: 3px;
    top: 1px;
    width: 4px;
    height: 6px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

span.error-text {
    float: left;
    color: var(--mured);
    padding: 2px 0;
    font: normal normal normal 14px/16px Source Sans Pro;
}

@media screen and (max-width: 880px) {
    .contact {


        &__first-row,
        &__second-row {
            width: 100%;
        }

        &__second-row {
            margin-top: 30px;
        }

        &__list {

            margin: 10px 0;

            .list-item {
                display: flex;
                align-items: center;
                padding: 10px 0;
                border-bottom: 1px solid #E0E0E0;
            }

        }

        &__map {
            width: 100%;
            height: 380px;
            background-color: #707070;
        }

        &__form {
            display: flex;
            flex-direction: column;
            margin: 0 auto;

            .form-item {
                select {
                    width: 160px;
                }

            }


            .contact-cell-2x {
                grid-template-columns: 1fr;
            }

            .form-select {
                flex-direction: row;
                justify-content: space-between;
            }

            .form-checkbox {
                flex-direction: row;
                align-items: center;

            }


        }

        .all-contact {
            &__content {
                justify-content: center;
            }

        }


        &__content {
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        }
    }
}
</style>
